<template>
  <div class="upLoadFilesBox">
    <div class="noImg" v-if="url == ''" @click="androidUploadFile">
      <span>
        <i><svg viewBox="64 64 896 896" data-icon="plus" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z"></path><path d="M176 474h672q8 0 8 8v60q0 8-8 8H176q-8 0-8-8v-60q0-8 8-8z"></path></svg></i>
      </span>
    </div>
    <img v-else :src="url" alt="" @click="showMenu">
    <div class="imgBg" @click="hidButton" v-show="showButton"></div>
    <div class="imgButton" v-show="showButton" @click="hidButton">
      <span @click="deleteImg">
        <i aria-label="icon: delete" tabindex="-1" class="anticon anticon-delete" title="Remove file"><svg viewBox="64 64 896 896" data-icon="delete" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z"></path></svg></i>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "uploadFile",
  props:['url','index'],
  data() {
    return {
      showButton:false
    }
  },
  mounted() {

  },
  methods:{
    androidUploadFile(){
      this.$emit('androidUploadFile')
    },
    showMenu(){
      this.showButton = true;
    },
    deleteImg(){
      this.showButton = false;
      this.$emit('deleteImg', this.index)
    },
    hidButton(){
      this.showButton = false;
    }
  }
}
</script>

<style scoped>
.upLoadFilesBox{
  position: relative;
  font-size: 32px;
  color: #999;
  display: flex;
  align-items: center;
  width: 104px;
  height: 104px;
  margin-right: 8px;
  margin-bottom: 8px;
  justify-content: space-around;
  text-align: center;
  background-color: #fafafa;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
  transition: border-color 0.3s ease;
}
.upLoadFilesBox>img{
  width: 100%;
  height: 100%;
  object-fit:cover;
}
.noImg{
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  text-align: center;
}
.imgBg{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: black;
  opacity: 0.5;
  transition: all 0.3s;
}
.imgButton{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.imgButton>span{
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 10;
  white-space: nowrap;
  transform: translate(-50%, -50%);
  transition: all 0.3s;
}
</style>
